<template>
  <!-- Component for displaying Related Books and Tours -->
  <div class="books-tours-container">
    <div class="itinerary-book" v-if="books && books.length > 0">
      <div class="itinerary-book-label">
        Related Featured
        <span v-if="books.length > 1">Books</span>
        <span v-else>Book</span>
      </div>
      <div
        class="itinerary-book-container"
        v-for="book in books"
        :key="returnValueInLanguage('en', book).bookId"
      >
        <!-- Show solid color if there is no image available -->
        <div
          class="book-image"
          :style="[
            returnValueInLanguage('en', book).bookCoverImage &&
            returnValueInLanguage('en', book).bookCoverImage.length > 0
              ? {
                  backgroundImage:
                    'url(' +
                    returnValueInLanguage('en', book).bookCoverImage +
                    ')',
                }
              : { backgroundColor: '#006950' },
          ]"
        ></div>
        <div class="book-info">
          <a :href="returnValueInLanguage('en', book).readMore" target="_blank">
            {{ returnValueInLanguage("en", book).title }}
          </a>
          <div
            class="itinerary-book-intro"
            v-html="returnValueInLanguage('en', book).intro"
          ></div>
        </div>
      </div>
    </div>
    <div class="itinerary-tour" v-if="tours && tours.length > 0">
      <div class="itinerary-tour-label">
        Related MWNF
        <span v-if="tours.length > 1">Tours</span>
        <span v-else>Tour</span>
      </div>
      <div
        class="itinerary-tour-container"
        v-for="tour in tours"
        :key="returnValueInLanguage('en', tour).tourId"
      >
        <div
          class="tour-image"
          :style="[
            returnValueInLanguage('en', tour).tourImage &&
            returnValueInLanguage('en', tour).tourImage.length > 0
              ? {
                  backgroundImage:
                    'url(' + returnValueInLanguage('en', tour).tourImage + ')',
                }
              : { backgroundColor: '#006950' },
          ]"
        ></div>
        <div class="tour-info">
          <a :href="returnValueInLanguage('en', tour).readMore" target="_blank">
            {{ returnValueInLanguage("en", tour).title }}
          </a>
          <div
            class="itinerary-tour-intro"
            v-html="returnValueInLanguage('en', tour).intro"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import language from "../mixins/language.js";
export default {
  name: "BooksTours",
  props: {
    books: Array,
    tours: Array,
  },
  mixins: [language],
};
</script>

<style scoped lang="scss">
.itinerary-book,
.itinerary-tour {
  width: 100%;
}
.itinerary-book-label,
.itinerary-tour-label {
  @include headings;
  @include font-size-3;
  margin-top: 30px;
  margin-bottom: 20px;
}
.itinerary-book-container,
.itinerary-tour-container {
  display: flex;
  height: 200px;
  width: 100%;
  box-shadow: 0px 2px 8px $light-grey;
  margin-bottom: 20px;
}
.book-image,
.tour-image {
  height: 100%;
  width: 165px;
  background-position: center;
  background-size: cover;
}
.book-info,
.tour-info {
  @include texts;
  @include font-size-7;
  height: 100%;
  width: 100%;
  padding: 30px;
}
.book-info a,
.tour-info a {
  font-weight: bold;
}
.itinerary-book-intro,
.itinerary-tour-intro {
  margin-top: 10px;
}

@media only screen and (max-width: 624px) {
  .itinerary-book-label,
  .itinerary-tour-label {
    @include font-size-4;
  }
  .itinerary-book-container,
  .itinerary-tour-container {
    flex-direction: column;
    height: auto;
  }
  .book-image,
  .tour-image {
    height: 175px;
    width: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-color: $dark-green;
  }
}
</style>
